import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveVehicleProjectPermissionsMutationVariables = Types.Exact<{
  input: Types.RemoveVehicleProjectPermissionsInput;
}>;


export type RemoveVehicleProjectPermissionsMutation = { __typename?: 'Mutation', removeVehicleProjectPermissions: { __typename?: 'RemoveVehicleProjectPermissionsPayload', user?: { __typename?: 'User', id: string } | null } };


export const RemoveVehicleProjectPermissionsDocument = gql`
    mutation RemoveVehicleProjectPermissions($input: RemoveVehicleProjectPermissionsInput!) {
  removeVehicleProjectPermissions(input: $input) {
    user {
      id
    }
  }
}
    `;
export type RemoveVehicleProjectPermissionsMutationFn = Apollo.MutationFunction<RemoveVehicleProjectPermissionsMutation, RemoveVehicleProjectPermissionsMutationVariables>;

/**
 * __useRemoveVehicleProjectPermissionsMutation__
 *
 * To run a mutation, you first call `useRemoveVehicleProjectPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVehicleProjectPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVehicleProjectPermissionsMutation, { data, loading, error }] = useRemoveVehicleProjectPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveVehicleProjectPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveVehicleProjectPermissionsMutation, RemoveVehicleProjectPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveVehicleProjectPermissionsMutation, RemoveVehicleProjectPermissionsMutationVariables>(RemoveVehicleProjectPermissionsDocument, options);
      }
export type RemoveVehicleProjectPermissionsMutationHookResult = ReturnType<typeof useRemoveVehicleProjectPermissionsMutation>;
export type RemoveVehicleProjectPermissionsMutationResult = Apollo.MutationResult<RemoveVehicleProjectPermissionsMutation>;
export type RemoveVehicleProjectPermissionsMutationOptions = Apollo.BaseMutationOptions<RemoveVehicleProjectPermissionsMutation, RemoveVehicleProjectPermissionsMutationVariables>;